export type { ExcelSheetData } from 'screens/business/budgets/budget/lines/importStructure/utils/types';

export type ElementImportField = string;

export interface MappingFieldOption {
    value: string;
    label: string;
}

export const FIXED_IMPORT_FIELDS: MappingFieldOption[] = [
    { value: 'reference', label: 'Referência' },
    { value: 'name', label: 'Nome' },
    { value: 'fornecedor', label: 'Fornecedor' },
    { value: 'price', label: 'Preço de venda sem impostos' },
    { value: 'familyName', label: 'Família do elemento' },
    { value: 'subFamilyName', label: 'Subfamília do elemento' },
    { value: 'additionalCoefficient', label: 'Coeficiente adicional' },
];

export interface ElementColumnMappingEntry {
    excelColumnIndex: number;
    excelColumnName: string;
    elementField: string | null;
}

export interface ElementImportRow {
    rowIndex: number;
    // 1-based spreadsheet row number, used to resolve cross-row price references (e.g. "E1422").
    sheetRow: number;
    familyId: string | null;
    subFamilyId: string | null;
    elementTypeId: string | null;
    workTypeId: string | null;
    unitId: string | null;
    rawCells: string[];
    formattedCells: string[];
    // Cell formula text per column (OOXML canonical), aligned with rawCells. '' when no formula.
    formulaCells: string[];
    editedCells?: Record<number, string>;
}

export type PriceClassification = 'INHERIT' | 'OWN' | 'FIXED';

/** Per-row outcome of the price-formula preview, indexed by ElementImportRow.rowIndex. */
export interface PriceFormulaPreview {
    rowIndex: number;
    classification: PriceClassification;
    // Token formula with M_ELEMREF__IMPORTROW<idx>_E placeholders (null when INHERIT).
    priceExpressionTemplate: string | null;
    // Human-readable formula (tokens replaced by @labels); null when INHERIT.
    displayFormula?: string | null;
}
